<template>

    <div class="row">
        <div class="col-sm-4 col-sm-offset-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Gebruikersnaam wijzigen</h2>
                </div>
                <div class="box-body">
                    <div class="form-group">
                        <label class="control-label">Huidige gebruikersnaam</label>
                        <input type="text" class="form-control" disabled
                            :value="currentUsername"
                        />
                    </div>
                    <div :class="{'form-group':true, 'has-error': errors.has('username')}">
                        <label for="username">Nieuwe gebruikersnaam:</label>
                        <div class="input-group">
                            <input type="text" id="username" class="form-control" tabindex="1"
                                v-model="form.newusername"
                                @focus="clear()"
                                @blur="check($event)"
                            />
                            <span v-if="checked.indexOf('username') !== -1" class="input-group-addon successbg"><i class="mdi mdi-check"></i></span>
                            <span v-else-if="alerts.indexOf('username') !== -1" class="input-group-addon dangerbg" v-tooltip="'Er is een ongeldige waarde'"><i class="mdi mdi-alert-circle-outline"></i></span>
                            <span v-else class="input-group-addon" v-tooltip="'Te controleren'"><i class="mdi mdi-dots-horizontal"></i></span>
                        </div>
                        <span v-if="errors.has('username')" class="help-block">{{ errors.get('username') }}</span>
                    </div>
                    <p class="form-control-static">Wanneer het gebruikersnaam van een gebruiker wordt aangepast, moet ook het wachtwoord opnieuw ingesteld worden.</p>
                    <div class="form-group">
                        <label for="password">Nieuw wachtwoord:</label>
                        <input type="password" id="password" tabindex="1" class="form-control" v-model="form.password" />
                        <span class="help-block">Een willekeurig wachtwoord: <strong v-text="randomPassword"></strong></span>
                    </div>
                    <div class="text-right">
                        <button class="btn btn-primary btn-sm" @click="onSubmit" :disabled="!canSubmit">Opslaan</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from "axios";
import Errors from "../../Errors";
import generatePassword from "../../helpers/generatePassword";

export default {

    computed: {

        canSubmit() {
            return this.alerts.length === 0 &&
                this.checked.length > 0 &&
                this.posting === false &&
                this.form.newusername !== '' &&
                this.form.newusername !== this.currentUsername &&
                this.form.password !== '';
        },

        postdata() {
            return {
                username: this.form.newusername,
                password: this.form.password,
            };
        },

        randomPassword() {
            return generatePassword(12);
        },

    },

    data() {
        return {
            alerts:[],
            checked:[],
            errors:new Errors,
            form: {
                newusername:'',
                password:'',
            },
            posting:false,
        }
    },

    methods: {

        check(event) {
            let field = 'username';
            let value = event.target.value;
            if (value === "") {
                return;
            }
            let data = {};
            data[field] = value;
            axios.get(this.route('api.v1.users.usernamecheck'), {params: data})
                .then(resp => {
                    if (resp.data.status === "OK") {
                        this.checked.push(field);
                    } else {
                        this.alerts.push(field);
                        let errors = {};
                        errors[field] = ["Deze waarde is in gebruik. Kies s.v.p. een andere waarde"];
                        this.errors.record(errors);
                    }
                });
        },

        clear() {
            this.checked = [];
            this.errors.clear('username');
            this.alerts = [];
        },

        onSubmit(){
            this.posting = true;
            axios.post(this.route('api.v1.users.changeusername', {user_uuid: this.userUuid}), this.postdata)
                .then(() => {
                    this.$snotify.success('De gebruikersnaam is gewijzigd');
                    this.$emit('usernameChangeCompleted');
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het aanpassen van de gebruikers'))
                .finally(() => this.posting = false);
        },
    },

    name:"UsersChangeUsernameForm",

    props: {
        currentUsername: {
            type:String,
            required:true,
        },
        userUuid: {
            type:String,
            required:true,
        },
    },
}

</script>
